// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction="column"
      sx={{ gap: 0.5, alignItems: 'center', justifyContent: 'center', p: '24px 16px 0px', mt: 'auto', textAlign: 'center' }}
    >
      <Typography variant="caption">제이세영|서울특별시 양천구 목동중앙남로16나길 33, 202호</Typography>
      <Typography variant="caption">사업자등록번호 : 378-25-01884|대표자 : 장원석|이메일 : ja8685@naver.com</Typography>
      <Typography variant="caption">Copyright© 2026 J Seyoung. ALL RIGHT RESERVED.</Typography>
    </Stack>
  );
}
